<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps<{
  isCheckMode: boolean;
  hasExistingCheck: boolean;
  taskCompleted: boolean;
  isBlocked: boolean;
}>();

const emit = defineEmits<{
  'enter-check': [];
}>();
</script>

<template>
  <footer v-if="!isCheckMode" class="flex-grow-0 pa-4 pt-0">
    <v-btn
      block
      size="x-large"
      class="typography-button-lg"
      :color="hasExistingCheck ? undefined : 'primary'"
      :variant="hasExistingCheck ? 'outlined' : 'elevated'"
      :prepend-icon="hasExistingCheck ? 'mdi-restart' : undefined"
      :disabled="taskCompleted || isBlocked"
      data-testid="check-asset-panel-run-check-btn"
      :data-blocked="isBlocked ? true : undefined"
      :data-has-existing-check="hasExistingCheck ? true : undefined"
      @click="emit('enter-check')">
      {{ hasExistingCheck ? t('checkAssetPanel.rerunCheck') : t('checkAssetPanel.runCheck') }}
    </v-btn>
  </footer>
</template>
